// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__w7qH5 {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 505px;
  min-height: var(--SIZE_400);
  background: var(--COLOR_FOREGROUND);
}

.styles_headerBlock__9FGo2 {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: var(--PADDING_24) var(--PADDING_24) var(--PADDING_0);
  /* border-bottom: var(--SIZE_BORDER) solid var(--COLOR_PRIMARY_350); */
}

.styles_closeStyle__y5CVn {
  padding-top: var(--PADDING_4);
  padding-right: var(--PADDING_4);
  border: 0;
  background: none;
  align-self: flex-start;
  cursor: pointer;
}

.styles_mainInfoBlock__s47U3 {
  width: 100%;
  height: max-content;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: var(--MARGIN_24);
}

.styles_afterAvatarBlock__KpOLW {
  display: flex;
  flex-direction: column;
  margin-left: var(--MARGIN_16);
}

.styles_nameAndBadgeBlock__6a82C {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.styles_badgeStyle__B9srE {
  width: var(--SIZE_10);
  height: var(--SIZE_10);
  border-radius: var(--RADIUS_5);
  background-color: var(--COLOR_SUCCESS_500);
}

.styles_nameTitleTextStyle__HiQl9 {
  padding-right: var(--PADDING_8);
  padding-bottom: var(--PADDING_4);
  font-family: var(--FONT_SEMIBOLD);
  font-style: normal;
  font-weight: var(--WEIGHT_600);
  font-size: var(--FONT_SIZE_24);
  line-height: var(--LINE_HEIGHT_32);
  color: var(--COLOR_GRAY_900);
}

.styles_nameSubTitleTextStyle__4nW9L {
  padding-bottom: var(--PADDING_18);
  font-family: var(--FONT_DEFAULT);
  font-style: normal;
  font-weight: var(--WEIGHT_400);
  font-size: var(--FONT_SIZE_SUB_TITLE);
  line-height: var(--LINE_HEIGHT_24);
  color: var(--COLOR_GRAY_600);
}

.styles_sequenceBlock__ZsZAa {
  display: flex;
  flex-direction: row;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/routes/modals/EditCreatorModal/styles.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,6DAA6D;EAC7D,sEAAsE;AACxE;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,SAAS;EACT,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,8BAA8B;EAC9B,0CAA0C;AAC5C;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;EAChC,iCAAiC;EACjC,kBAAkB;EAClB,8BAA8B;EAC9B,8BAA8B;EAC9B,kCAAkC;EAClC,4BAA4B;AAC9B;;AAEA;EACE,iCAAiC;EACjC,gCAAgC;EAChC,kBAAkB;EAClB,8BAA8B;EAC9B,qCAAqC;EACrC,kCAAkC;EAClC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n  width: 505px;\n  min-height: var(--SIZE_400);\n  background: var(--COLOR_FOREGROUND);\n}\n\n.headerBlock {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  padding: var(--PADDING_24) var(--PADDING_24) var(--PADDING_0);\n  /* border-bottom: var(--SIZE_BORDER) solid var(--COLOR_PRIMARY_350); */\n}\n\n.closeStyle {\n  padding-top: var(--PADDING_4);\n  padding-right: var(--PADDING_4);\n  border: 0;\n  background: none;\n  align-self: flex-start;\n  cursor: pointer;\n}\n\n.mainInfoBlock {\n  width: 100%;\n  height: max-content;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  margin-bottom: var(--MARGIN_24);\n}\n\n.afterAvatarBlock {\n  display: flex;\n  flex-direction: column;\n  margin-left: var(--MARGIN_16);\n}\n\n.nameAndBadgeBlock {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.badgeStyle {\n  width: var(--SIZE_10);\n  height: var(--SIZE_10);\n  border-radius: var(--RADIUS_5);\n  background-color: var(--COLOR_SUCCESS_500);\n}\n\n.nameTitleTextStyle {\n  padding-right: var(--PADDING_8);\n  padding-bottom: var(--PADDING_4);\n  font-family: var(--FONT_SEMIBOLD);\n  font-style: normal;\n  font-weight: var(--WEIGHT_600);\n  font-size: var(--FONT_SIZE_24);\n  line-height: var(--LINE_HEIGHT_32);\n  color: var(--COLOR_GRAY_900);\n}\n\n.nameSubTitleTextStyle {\n  padding-bottom: var(--PADDING_18);\n  font-family: var(--FONT_DEFAULT);\n  font-style: normal;\n  font-weight: var(--WEIGHT_400);\n  font-size: var(--FONT_SIZE_SUB_TITLE);\n  line-height: var(--LINE_HEIGHT_24);\n  color: var(--COLOR_GRAY_600);\n}\n\n.sequenceBlock {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__w7qH5`,
	"headerBlock": `styles_headerBlock__9FGo2`,
	"closeStyle": `styles_closeStyle__y5CVn`,
	"mainInfoBlock": `styles_mainInfoBlock__s47U3`,
	"afterAvatarBlock": `styles_afterAvatarBlock__KpOLW`,
	"nameAndBadgeBlock": `styles_nameAndBadgeBlock__6a82C`,
	"badgeStyle": `styles_badgeStyle__B9srE`,
	"nameTitleTextStyle": `styles_nameTitleTextStyle__HiQl9`,
	"nameSubTitleTextStyle": `styles_nameSubTitleTextStyle__4nW9L`,
	"sequenceBlock": `styles_sequenceBlock__ZsZAa`
};
export default ___CSS_LOADER_EXPORT___;
